import { AlertTypes } from '@rappider/rappider-components/utils';

export const NO_FIELD_ALERT = {
  type: AlertTypes.Warning,
  title: 'CONTENT_EDITOR_MODULE.COMPONENT_DATA_SUBSCRIPTION_MODAL.NO_FIELD',
  description: 'CONTENT_EDITOR_MODULE.COMPONENT_DATA_SUBSCRIPTION_MODAL.THERE_IS_NO_FIELD_TO_SELECT',
  closeable: false
};
